
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `הוסיפו למסך הבית לחוויה מקיפה וגישה קלה.`,
's224cbcec014ef6b5': `לחצו על שיתוף בסרגל הניווט`,
's37a9e8aec5713460': `עוד`,
's386eca8362ff6155': `לחצו על עוד אם אין סמל שיתוף`,
's4e1e10a6ca408245': `הקישו על "הוספה למסך הבית"`,
's6196153c4b0c1ea0': `התקנה`,
's633502f7cff4f847': `פתחו את תפריט הדפדפן`,
's681e399d63311fba': `הצג גלריה`,
's7f0591f08e318eda': `לחצו על עוד בתפריט שיתוף`,
's8114bd55cae5a22b': `לחצו על הוספה ל-Dock`,
's922329d6f6213590': `הוסיפו ל-Dock`,
's9af56bf005b49c74': `גללו למטה עד "הוספה למסך הבית"`,
'sa5ef80b4bb9b39f8': `הסתרת גלריה`,
'sba52286c21552a4e': `התקינו במכשירכם לחוויה מקיפה וגישה קלה.`,
'sc16e00a7a8b2fde2': `חזרה`,
'scdaf4bbff76674c8': `הוספה למסך הבית`,
'se0e473adfda8066c': `פתחו בדפדפן הראשי שלכם`,
'se740f75b95a51807': `הוסיפו ל-Dock לחוויה מקיפה וגישה קלה.`,
'sfea652f6580ff086': `לאתר זה יש פונקציונליות של אפליקציה.`,
    };
  